import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useFreecodeContextData, useFreecodeContextRun } from 'hooks/useContext';
import * as authActions from 'global/actions/authActions';
import { useActions } from 'hooks/useActions';
import services from 'api/services';
const { InputService } = services;

export default function useExerciseAutoSave() {
  const { exerciseId } = useParams();

  const { isCommunityUser } = useSelector((state) => state.auth);
  const { verifyAuthState } = useActions(authActions);

  const { inputRef, setInput } = useFreecodeContextData();
  const { codeSolRef, languageRef, levelToRunRef } = useFreecodeContextRun();

  const autoSaveIntervalRef = useRef(undefined);

  useEffect(() => {
    const performAutoSave = async () => {
      try {
        if (!isCommunityUser) return;
        if (inputRef.current?.lastAutoSave?.code === codeSolRef.current) return;
        await InputService.autoSaveExerciseCode({
          test: exerciseId,
          code: codeSolRef.current,
          language: languageRef.current,
          levelToRun: levelToRunRef.current,
        });
        if (inputRef.current)
          setInput((oldInput) => ({
            ...oldInput,
            lastAutoSave: { ...oldInput.lastAutoSave, code: codeSolRef.current },
          }));
      } catch (error) {
        console.error('Auto save error:', error);
        verifyAuthState();
      }
    };
    clearInterval(autoSaveIntervalRef.current);
    autoSaveIntervalRef.current = setInterval(performAutoSave, 5000);
    return () => {
      clearInterval(autoSaveIntervalRef.current);
    };
  }, [exerciseId, isCommunityUser, codeSolRef, setInput, inputRef, languageRef, levelToRunRef, verifyAuthState]);
}
